import store from '@/store';
import vuetify from '@/plugins/vuetify';
import {Vue} from 'vue-property-decorator';
import DialogConfirm from '@/components/DialogConfirm.vue';
import {Dialog, DialogConfirmOptions} from '@/types/dialog';

export const defaultDialogOptions: DialogConfirmOptions = {
  title: 'Confirmation',
  message: '',
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  maxWidth: '500px',
  color: 'primary',
  noCancel: false,
  noTitle: false,
  center: false,
  icon: '',
  cardProps: {},
};

export function createDialog(
  options: DialogConfirmOptions = defaultDialogOptions,
) {
  const container = document.querySelector('[data-app=true]') || document.body;
  return new Promise(resolve => {
    const DialogComponent = Vue.extend(DialogConfirm);
    const instance = new DialogComponent({
      vuetify,
      store,
      propsData: {value: true, ...options},
      destroyed() {
        container.removeChild(this.$el);
        resolve(this.$data.innerValue);
      },
    });
    instance.$mount();
    container.appendChild(instance.$el);
  });
}

export default <Dialog>{
  confirm(title: string, message: string, options?: DialogConfirmOptions) {
    return createDialog({title, message, ...options});
  },
  info(message: string, options?: DialogConfirmOptions) {
    return createDialog({
      message,
      title: 'Info',
      type: 'info',
      color: 'info',
      noTitle: true,
      noCancel: true,
      center: true,
      confirmText: 'OK',
      icon: 'info',
      ...options,
    });
  },
  error(message: string, options?: DialogConfirmOptions) {
    return createDialog({
      message,
      title: 'Error',
      type: 'error',
      color: 'error',
      noTitle: true,
      noCancel: true,
      center: true,
      confirmText: 'OK',
      icon: 'error',
      ...options,
    });
  },
  success(message: string, options?: DialogConfirmOptions) {
    return createDialog({
      message,
      title: 'Success!',
      type: 'success',
      color: 'success',
      noTitle: true,
      noCancel: true,
      center: true,
      confirmText: 'OK',
      icon: 'success',
      ...options,
    });
  },
  delete(title: string, message: string, options?: DialogConfirmOptions) {
    return createDialog({
      title: title || 'Delete Confirmation',
      message: message || 'Are you sure want to delete this item?',
      confirmText: 'Delete',
      cancelText: 'No',
      color: 'error',
      icon: 'error',
      center: false,
      noTitle: true,
      btnConfirmProps: {
        color: 'error',
      },
      ...options,
    });
  },
};
